import { render, staticRenderFns } from "./clientService.vue?vue&type=template&id=79d66a15"
import script from "./clientService.vue?vue&type=script&lang=js"
export * from "./clientService.vue?vue&type=script&lang=js"
import style0 from "./clientService.vue?vue&type=style&index=0&id=79d66a15&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports